module.exports = __webpack_public_path__ + "img/option.3bc31139.png";